<!--@format-->
<template>
    <div class="loading-animation-popup">
        <section class="animation-container">
            <loading-glasshive />
        </section>
    </div>
</template>

<script>
const LoadingGlasshive = () => import('@/assets/animations/loading-glasshive');
export default {
    name: 'loading-animation-popup',

    components: {
        'loading-glasshive': LoadingGlasshive,
    },
};
</script>

<style>
.loading-animation-popup {
    display: flex;
    align-items: center;
    justify-content: center;
}

.success-animation-popup .animation-container {
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>
